import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/yjapp/portal/client/user/h5Reg',
    headers: {
      isToken: false
    },
    method: 'post',
    params: data
  })
}

// 获取验证码
export function getCodeImg(data) {
  return request({
    url: '/yjapp/portal/client/sendCheckCode',
    headers: {
      isToken: false
    },
    method: 'post',
    timeout: 20000,
    params: data

  })
}

// 根据userid获取信息
export function qryH5RegInfo(data) {
  return request({
    url: '/yjapp/portal/client/qryH5RegInfo',
    headers: {
      isToken: false
    },
    method: 'post',
    timeout: 20000,
    params: data

  })
}